/* @flow */

export const capitalizeFirstLetter = (string: string) => {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

export const toSnakeCase = (s: string): string => {
  return s.replace(/\.?([A-Z])/g, (_match, p1) => `_${p1.toLowerCase()}`).replace(/^_/, '')
}

export const toCamelCase = (s: string): string => {
  return s
    .split('_')
    .map((p, index) => {
      if (index > 0) return capitalizeFirstLetter(p)
      return p
    })
    .join('')
}

// replaceWithObject({ pull_id: 1 }, '/my/url/${pull_id}')
export const replaceWithObject = (obj: Object, replacer: string = '${key}') => (str: string): string => {
  let keys = Object.keys(obj)
  for (let key of keys) {
    const keyReplacer = replacer.replace('key', key)
    str = str.replace(keyReplacer, obj[key])
  }
  return str
}

export const regexEscape = (string: string): string => {
  return string.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&')
}
